// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"9cecd50798d013ea6548","777":"f0175fec8ce09c8e8910","939":"c22c38f0049a47354d59"}[chunkId] + ".js";
};